import { render, staticRenderFns } from "./ChangeCourse.vue?vue&type=template&id=e54dcf08&scoped=true&"
import script from "./ChangeCourse.vue?vue&type=script&lang=js&"
export * from "./ChangeCourse.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCourse.vue?vue&type=style&index=0&id=e54dcf08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54dcf08",
  null
  
)

export default component.exports